import { Card, CardContent, Typography, Box } from "@mui/material";
import { Luggage } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const BaggageOptions = () => {
  const { t } = useTranslation("common");

  return (
    <>
      <Card variant="outlined">
        <CardContent>
          <Box display="flex" alignItems="center">
            <Box bgcolor="#f3f3f3" p={1} borderRadius={1}>
              <Luggage fontSize="large" color="success" />
            </Box>
            <Box pl={1}>
              <Typography variant="subtitle1" fontWeight="bold">
                {t("checkout.baggageIncluded")}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t("checkout.handLuggage")}
                <br />
                {t("checkout.touristBaggage")}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default BaggageOptions;